"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WizardRouter = void 0;
const core_1 = require("@veeam/core");
class WizardRouter extends core_1.Router {
    constructor(interactable, viewController, steps) {
        super(interactable);
        this.viewController = viewController;
        this.steps = steps;
        this.current = null;
        this.stepBuildersById = {};
        this.stepByBuilder = new Map();
        interactable.router = this;
        this.steps.forEach((step, index) => {
            const id = step.id;
            interactable.registerStepId({ id, index, canCancel: step.canCancel });
            this.stepBuildersById[id] = step;
        });
    }
    getBuildStepById(stepId) {
        return __awaiter(this, void 0, void 0, function* () {
            const stepBuilder = this.stepBuildersById[stepId];
            if (!stepBuilder) {
                throw new Error(`WizardRouter error: step with id ${stepId} not registered`);
            }
            let step = this.stepByBuilder.get(stepBuilder);
            if (!step) {
                step = yield stepBuilder.build();
                this.stepByBuilder.set(stepBuilder, step);
            }
            return step;
        });
    }
    attachSteps() {
        return __awaiter(this, void 0, void 0, function* () {
            this.steps.forEach((step) => {
                this.viewController.registerTabViewController(step.id, step.tabViewController);
            });
        });
    }
    switchStepById(stepId) {
        return __awaiter(this, void 0, void 0, function* () {
            const step = yield this.getBuildStepById(stepId);
            if (this.current) {
                yield this.detachChild(this.current);
            }
            yield this.attachChild(step.router);
            this.viewController.replaceBody(step.router.bodyViewController);
            this.current = step.router;
            this.currentStepId = stepId;
        });
    }
    completeStepById(stepId) {
        return __awaiter(this, void 0, void 0, function* () {
            const step = yield this.getBuildStepById(stepId);
            const isNotCurrent = this.current !== step.router;
            if (isNotCurrent) {
                yield this.attachChild(step.router);
            }
            const result = yield step.actionable.complete();
            if (isNotCurrent) {
                yield this.detachChild(step.router);
            }
            return result;
        });
    }
    canLeaveCurrentStep() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.currentStepId) {
                const currentStep = yield this.getBuildStepById(this.currentStepId);
                return yield currentStep.actionable.willLeave();
            }
            return false;
        });
    }
}
exports.WizardRouter = WizardRouter;
//# sourceMappingURL=WizardRouter.js.map